import React from "react";
import { formatPhone } from "@/lib/utils";

export default function HouseholdContactDetails({ phone, email, compact = false, testId, hiddenFields = [] }) {
  const valueClass = compact ? "text-xs" : "text-sm";
  return (
    <div
      className={`${compact ? "space-y-0.5" : "grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-1"} ${valueClass}`}
      style={{ color: "var(--fb-text-muted)" }}
      data-testid={testId}
    >
      <div>
        <span className="font-semibold">Phone:</span>{" "}
        <span>{hiddenFields.includes("phone") ? "Hidden" : phone ? formatPhone(phone) : "Not on file"}</span>
      </div>
      <div style={{ overflowWrap: "anywhere" }}>
        <span className="font-semibold">Email:</span>{" "}
        <span>{hiddenFields.includes("email") ? "Hidden" : email || "Not on file"}</span>
      </div>
    </div>
  );
}
